// removed by extract-text-webpack-plugin
module.exports = {"accountNo":"_1SrfY","legalName":"_3Xfq9","contractType":"AepJF","balance":"_2uzqR","description":"_3XuhP","view":"_15F2C","created":"_25cfV","lockedaccount":"_7JqhT","header":"NlBqj"};


//////////////////
// WEBPACK FOOTER
// ./src/views/AccountsAndLoans/columns.scss
// module id = 257
// module chunks = 0